import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { compose } from '../../services/utilityFunctions';
import translate from '../translate';
import withCSRF from '../withCSRF';
import Notifications from '../../services/notifications';
import i18n from '../../services/i18n';

const MondialRelay = ({ config, onPickupSelection }) => {
  const [pickupInfo, setPickupInfo] = useState('');

  const mondialConfig = MondialRelay.defaultProps.config;
  if (config?.Brand) {
    mondialConfig.Brand = config.Brand;
  }
  if (config?.PostCode) {
    mondialConfig.PostCode = config.PostCode;
  }
  if (config?.AllowedCountries) {
    mondialConfig.AllowedCountries = config.AllowedCountries;
  }
  if (config?.Country) {
    mondialConfig.Country = config.Country;
  }

  // Setting up the widget
  useEffect(() => {
    $(document).ready(() => {
      $('#Zone_Widget').MR_ParcelShopPicker({
        ...mondialConfig,
        OnParcelShopSelected (data) {
          setPickupInfo({
            pickupId: `${data.Pays}-${data.ID}`,
            address_1: _.startCase(_.camelCase(data.Adresse1)),
            address_2: _.startCase(_.camelCase(data.Adresse2)),
            zipCode: data.CP,
            city: _.startCase(_.camelCase(data.Ville)),
            countryCode: data.Pays,
            firstName: _.startCase(_.camelCase(data.Nom)),
            location: [parseFloat(data.Long.replace(',', '.')), parseFloat(data.Lat.replace(',', '.'))],
          });
        },
        OnNoResultReturned () {
          Notifications.showNotificationError(i18n.__('error'), i18n.__('ERROR.NO.RESULTS.MONDIAL_RELAY'));
        },
      });
    });
  }, []);

  // Send info to parent component
  useEffect(() => {
    onPickupSelection(pickupInfo);
  }, [pickupInfo]);

  // Render widget
  return (
    <div>
      {/* HTML Element in which the Parcelshop Picker Widget is loaded */ }
      <div id="Zone_Widget" />
      {/* HTML element to display the parcelshop selected, for demo only (use text). Should use hidden instead. */ }
       <input type="hidden" id="Target_Widget" />
    </div>
  );
};

MondialRelay.propTypes = {
  config: PropTypes.shape({
    // JQuery selector of the HTML element receiving the Parcelshop Number (ex: here, input type text, but should be input hidden)
    Target: PropTypes.string,
    /** Start: Settings for Parcelshop data access */
    // Code given by Mondial Relay, 8 characters (padding right with spaces)
    // BDTEST is used for development only => a warning appears
    Brand: PropTypes.string.isRequired, // Your Mondial Relay customer code
    // Default Country (2 letters) used for search at loading
    Country: PropTypes.string.isRequired,
    // Available Countries
    AllowedCountries: PropTypes.string.isRequired,
    // Default postal Code used for search at loading
    PostCode: PropTypes.string.isRequired,
    // Delivery mode (Standard [24R], XL [24L], XXL [24X], Drive [DRI])
    ColLivMod: PropTypes.string.isRequired,
    // Number of parcelshops requested (must be less than 20)
    NbResults: PropTypes.string.isRequired,
    EnableGeolocalisatedSearch: PropTypes.bool.isRequired, // Enables or disables Geo localization
    /** End: Settings for Parcelshop data access */
    /** Start: Display settings */
    // Enable Responsive (nb: non responsive corresponds to the Widget used in older versions=
    Responsive: PropTypes.bool.isRequired,
    // Show the results on Leaflet map usng OpenStreetMap.
    ShowResultsOnMap: PropTypes.bool.isRequired,
    /** End: Display settings */
  }),
  onPickupSelection: PropTypes.func.isRequired,
};

MondialRelay.defaultProps = {
  config: {
    Target: '#Target_Widget',
    Brand: 'BDTEST  ',
    Country: 'FR',
    PostCode: '59000',
    NbResults: '19',
    EnableGeolocalisatedSearch: false,
    Responsive: true,
    ShowResultsOnMap: true,
  },
};

export default compose(
  translate,
  withCSRF,
)(MondialRelay);
